import _ from 'lodash';

import * as EntityActions from 'app/entity/EntityActions';

const partiallyApplyEntityDefault = (actionCreator, { type }) =>
  _.partial(actionCreator, type);

// Iterates `EntityActions` and partially applies `entityConfig`
// to every action creator. Action creators can specify their own
// `partiallyApplyEntity` functions if they need a more complex
// partial application; otherwise `partiallyApplyEntityDefault`
// is provided.
const buildEntityActions = (type, selectors, api, customize = _.identity) => {
  const entityConfig = { type, selectors, api };
  const entityActions = Object.keys(EntityActions).reduce(
    (actions, actionName) => {
      const actionCreator = EntityActions[actionName];
      const {
        partiallyApplyEntity = partiallyApplyEntityDefault,
      } = actionCreator;
      const result = partiallyApplyEntity(actionCreator, entityConfig);
      // Most, but not all, action creators make sense to partially
      // apply with an entity. Those that don't make sense to do so
      // with can return `false` to avoid it.
      if (_.isFunction(result)) {
        actions[actionName] = result;
      }
      return actions;
    },
    {}
  );
  customize(entityActions);
  return entityActions;
};

export default buildEntityActions;
